var _mask, _rect, _mask2, _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnWired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3036_71534",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9.37402,
    width: 24,
    height: 19,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9.37402,
    width: 24,
    height: 19,
    rx: 1,
    stroke: "#172664",
    strokeWidth: 3,
    mask: "url(#path-2-inside-1_3036_71534)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_3036_71534",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4365 12.3418V9.37207H25.5635V12.3418L30.3154 12.3418V24.8135H13.6846V12.3418H18.4365Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4365 12.3418V13.8418H19.9365V12.3418H18.4365ZM18.4365 9.37207V7.87207H16.9365V9.37207H18.4365ZM25.5635 9.37207H27.0635V7.87207H25.5635V9.37207ZM25.5635 12.3418H24.0635V13.8418H25.5635V12.3418ZM30.3154 12.3418H31.8154V10.8418H30.3154V12.3418ZM30.3154 24.8135V26.3135H31.8154V24.8135H30.3154ZM13.6846 24.8135H12.1846V26.3135H13.6846V24.8135ZM13.6846 12.3418V10.8418H12.1846V12.3418H13.6846ZM18.4365 12.3418H19.9365V9.37207H18.4365H16.9365V12.3418H18.4365ZM18.4365 9.37207V10.8721H25.5635V9.37207V7.87207H18.4365V9.37207ZM25.5635 9.37207H24.0635V12.3418H25.5635H27.0635V9.37207H25.5635ZM25.5635 12.3418V13.8418L30.3154 13.8418V12.3418V10.8418L25.5635 10.8418V12.3418ZM30.3154 12.3418H28.8154V24.8135H30.3154H31.8154V12.3418H30.3154ZM30.3154 24.8135V23.3135H13.6846V24.8135V26.3135H30.3154V24.8135ZM13.6846 24.8135H15.1846V12.3418H13.6846H12.1846V24.8135H13.6846ZM13.6846 12.3418V13.8418H18.4365V12.3418V10.8418H13.6846V12.3418Z",
    fill: "#172664",
    mask: "url(#path-3-inside-2_3036_71534)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 31.8564H20.5",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 31.8564H29.5",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 29.8564L22.5 27.8564",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 32.1279,
    r: 1.75,
    stroke: "#172664",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnWired);
export default __webpack_public_path__ + "static/media/btn_wired.818f9f486f8db1d9279dae030b13663e.svg";
export { ForwardRef as ReactComponent };